import React, { useState, useEffect } from 'react';
import { X, Send, Loader } from 'lucide-react';
import api from './api/Api';
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function QuoteModal({ isOpen, onClose, isDarkMode, preSelectedService = null }) {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    servico: preSelectedService || '',
    mensagem: ''
  });

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const recaptchaRef = useRef(null);


  useEffect(() => {
    if (isOpen) {
      fetchServices();
      setFormData({
        nome: '',
        email: '',
        telefone: '',
        empresa: '',
        servico: preSelectedService || '',
        mensagem: ''
      });
      setSubmitStatus(null);
    }

 


  }, [isOpen, preSelectedService]);

  useEffect(() => {
    if (preSelectedService) {
      setFormData(prev => ({ ...prev, servico: preSelectedService }));
    }
  }, [preSelectedService]);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await api.ListServico();
      const dados = Array.isArray(response) ? response : [];
      setServices(dados);
    } catch (error) {
      console.error('Erro ao carregar serviços:', error);
      setServices([
        { id: 1, titulo: 'CCTV' },
        { id: 2, titulo: 'Cabeamento Estruturado' },
        { id: 3, titulo: 'Criação de Websites' },
        { id: 4, titulo: 'Software Personalizado' },
        { id: 5, titulo: 'Software Certificado pela AGT' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  
const handleSubmit = async (e) => {
  e.preventDefault();

  const captchaToken = recaptchaRef.current?.getValue();

  if (!captchaToken) {
    setSubmitStatus('error');
    toast.warning("Por favor, confirme o captcha antes de enviar.");
    return;
  }

  setSubmitting(true);
  setSubmitStatus(null);

  try {


  
    const response = await api.AddOrcamento({
      ...formData,
      captcha_token: captchaToken
    });

    
    setSubmitStatus('success');
    recaptchaRef.current?.reset();

    setTimeout(() => {
      onClose();
    }, 2000);

  } catch (error) {
    console.error('Erro detalhado:', error.response?.data || error.message);
    
    // Mostrar mensagem de erro específica
    const errorMsg = error.response?.data?.message || 'Erro ao enviar orçamento. Tente novamente.';
    toast.error(errorMsg);
    
    setSubmitStatus('error');
    recaptchaRef.current?.reset();
  } finally {
    setSubmitting(false);
  }
};




  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 z-[9998] bg-black/60 backdrop-blur-sm transition-opacity duration-300"
        onClick={handleBackdropClick}
        style={{ animation: 'fadeIn 0.3s ease-out' }}
      />
      
      <div className="fixed inset-0 z-[9999] overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-6 lg:p-8">
          <div 
            className={`relative w-full max-w-2xl transform rounded-2xl shadow-2xl transition-all duration-300 ${
              isDarkMode ? 'bg-gray-800 border border-white/10' : 'bg-white'
            }`}
            style={{ animation: 'scaleIn 0.3s ease-out' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className={`flex items-start justify-between p-4 sm:p-6 border-b ${
              isDarkMode ? 'border-white/10' : 'border-gray-200'
            }`}>
              <div className="flex-1 pr-4">
                <h2 className={`text-xl sm:text-2xl md:text-3xl font-bold ${
                  isDarkMode ? 'text-white' : 'text-gray-900'
                }`}>
                  Solicitar Orçamento
                </h2>
                <p className={`text-xs sm:text-sm mt-1 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>
                  Preencha o formulário e entraremos em contacto em até 24 horas
                </p>
              </div>
              <button
                onClick={onClose}
                className={`flex-shrink-0 p-2 rounded-lg transition-all ${
                  isDarkMode
                    ? 'hover:bg-gray-700 text-gray-400 hover:text-white'
                    : 'hover:bg-gray-100 text-gray-600 hover:text-gray-900'
                }`}
                aria-label="Fechar"
              >
                <X size={20} className="sm:w-6 sm:h-6" />
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-4 sm:space-y-5">
              {/* Nome */}
              <div>
                <label className={`block text-xs sm:text-sm font-semibold mb-1.5 sm:mb-2 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Nome Completo <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                  placeholder="Seu nome completo"
                  className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg outline-none transition-all ${
                    isDarkMode
                      ? 'bg-gray-700 border-2 border-gray-600 text-white placeholder-gray-400 focus:border-cyan-500'
                      : 'bg-gray-50 border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                  }`}
                />
              </div>

              {/* Email e Telefone */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className={`block text-xs sm:text-sm font-semibold mb-1.5 sm:mb-2 ${
                    isDarkMode ? 'text-gray-300' : 'text-gray-700'
                  }`}>
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="seu@email.com"
                    className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg outline-none transition-all ${
                      isDarkMode
                        ? 'bg-gray-700 border-2 border-gray-600 text-white placeholder-gray-400 focus:border-cyan-500'
                        : 'bg-gray-50 border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                    }`}
                  />
                </div>

                <div>
                  <label className={`block text-xs sm:text-sm font-semibold mb-1.5 sm:mb-2 ${
                    isDarkMode ? 'text-gray-300' : 'text-gray-700'
                  }`}>
                    Telefone <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleChange}
                    required
                    placeholder="+244 XXX XXX XXX"
                    className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg outline-none transition-all ${
                      isDarkMode
                        ? 'bg-gray-700 border-2 border-gray-600 text-white placeholder-gray-400 focus:border-cyan-500'
                        : 'bg-gray-50 border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                    }`}
                  />
                </div>
              </div>

              {/* Empresa */}
              <div>
                <label className={`block text-xs sm:text-sm font-semibold mb-1.5 sm:mb-2 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Empresa
                </label>
                <input
                  type="text"
                  name="empresa"
                  value={formData.empresa}
                  onChange={handleChange}
                  placeholder="Nome da sua empresa (opcional)"
                  className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg outline-none transition-all ${
                    isDarkMode
                      ? 'bg-gray-700 border-2 border-gray-600 text-white placeholder-gray-400 focus:border-cyan-500'
                      : 'bg-gray-50 border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                  }`}
                />
              </div>

              {/* Serviço */}
      <div>
                <label className={`block text-xs sm:text-sm font-semibold mb-1.5 sm:mb-2 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Serviço <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <select
                    name="servico"
                    value={formData.servico}
                    onChange={handleChange}
                    required
                    disabled={loading}
                    className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg outline-none transition-all ${
                      isDarkMode
                        ? 'bg-gray-700 border-2 border-gray-600 text-white focus:border-cyan-500'
                        : 'bg-gray-50 border-2 border-gray-200 text-gray-900 focus:border-blue-500'
                    } ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                  >
                    <option value="">
                      {loading ? 'Carregando serviços...' : 'Selecione um serviço'}
                    </option>
                    {!loading && services.map((service) => (
                      <option key={service.id} value={service.titulo}>
                        {service.titulo}
                      </option>
                    ))}
                    {!loading && <option value="Outros">Outros</option>}
                  </select>
                  {loading && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                      <Loader size={18} className="animate-spin text-blue-600" />
                    </div>
                  )}
                </div>
              </div>

              {/* Mensagem */}
              <div>
                <label className={`block text-xs sm:text-sm font-semibold mb-1.5 sm:mb-2 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  Mensagem <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  required
                  rows="4"
                  placeholder="Descreva o seu projeto ou necessidade..."
                  className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg outline-none transition-all resize-none ${
                    isDarkMode
                      ? 'bg-gray-700 border-2 border-gray-600 text-white placeholder-gray-400 focus:border-cyan-500'
                      : 'bg-gray-50 border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                  }`}
                ></textarea>
              </div>

              {/* Status Messages */}
              {submitStatus === 'success' && (
                <div className="p-3 sm:p-4 bg-green-500/10 border border-green-500/30 rounded-lg flex items-start space-x-3 animate-slide-in">
                  <div className="flex-shrink-0 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center mt-0.5">
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-green-500 font-medium text-xs sm:text-sm">
                    Orçamento enviado com sucesso! Entraremos em contacto em breve.
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-3 sm:p-4 bg-red-500/10 border border-red-500/30 rounded-lg flex items-start space-x-3 animate-slide-in">
                  <div className="flex-shrink-0 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center mt-0.5">
                    <X size={12} className="text-white" />
                  </div>
                  <p className="text-red-500 font-medium text-xs sm:text-sm">
                    Erro ao enviar orçamento. Por favor, tente novamente.
                  </p>
                </div>
              )}

<div className="flex justify-center">
<ReCAPTCHA
  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
  ref={recaptchaRef}
/>

</div>



              {/* Buttons */}
 <div className="flex flex-col sm:flex-row gap-3 pt-2 sm:pt-4">
                <button
                  type="submit"
                  disabled={submitting || loading}
                  className={`flex-1 flex items-center justify-center space-x-2 px-4 sm:px-6 py-3 sm:py-4 text-sm sm:text-base bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:shadow-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed ${
                    submitting ? 'animate-pulse' : ''
                  }`}
                >
                  {submitting ? (
                    <>
                      <Loader size={18} className="animate-spin sm:w-5 sm:h-5" />
                      <span>Enviando...</span>
                    </>
                  ) : (
                    <>
                      <Send size={18} className="sm:w-5 sm:h-5" />
                      <span>Enviar Pedido</span>
                    </>
                  )}
                </button>
                
                <button
                  type="button"
                  onClick={onClose}
                  disabled={submitting}
                  className={`px-4 sm:px-6 py-3 sm:py-4 text-sm sm:text-base rounded-lg font-semibold transition-all ${
                    isDarkMode
                      ? 'bg-gray-700 text-white hover:bg-gray-600'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  } disabled:opacity-50 disabled:cursor-not-allowed`}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-slide-in {
          animation: slideIn 0.3s ease-out;
        }

        /* Custom scrollbar for the overlay */
        .fixed.inset-0.overflow-y-auto::-webkit-scrollbar {
          width: 8px;
        }

        .fixed.inset-0.overflow-y-auto::-webkit-scrollbar-track {
          background: transparent;
        }

        .fixed.inset-0.overflow-y-auto::-webkit-scrollbar-thumb {
          background: ${isDarkMode ? 'rgba(75, 85, 99, 0.5)' : 'rgba(209, 213, 219, 0.5)'};
          border-radius: 4px;
        }

        .fixed.inset-0.overflow-y-auto::-webkit-scrollbar-thumb:hover {
          background: ${isDarkMode ? 'rgba(107, 114, 128, 0.7)' : 'rgba(156, 163, 175, 0.7)'};
        }

        /* Garantir que o modal seja rolável em telas pequenas */
        @media (max-height: 700px) {
          .min-h-full {
            min-height: auto;
            padding-top: 1rem;
            padding-bottom: 1rem;
          }
        }
      `}</style>
 
    </>
  );
}